import { render } from "./App.vue?vue&type=template&id=95d8adfc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=95d8adfc&lang=css"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__